import {
  AfterContentInit,
  Component,
  ElementRef,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
  inject,
  input,
  WritableSignal,
  signal,
  Signal,
  computed,
} from '@angular/core';
import { ServiceCategoryModel } from '@app/src/app/modules/service/classes/category/model/service.category.model';
import { NgOptimizedImage } from '@angular/common';
import { Translation, TranslationService } from '@ckmk/angular';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';

@Component({
  selector: 'service-category-menu-card',
  standalone: true,
  imports: [NgOptimizedImage, Translation],
  templateUrl: './service-category-menu-card.html',
  styleUrl: './service-category-menu-card.scss',
  host: {
    '[tabindex]': '0',
    '[title]': 'localTitle()',
    '[style]': 'styles()',
    '[class.is-active]': 'isActive()',
    '[class.is-current]': 'isCurrent()',
    '(click)': 'onClick($event)',
  },
  encapsulation: ViewEncapsulation.None,
})
export class ServiceCategoryMenuCard
  implements OnInit, OnChanges, OnDestroy, AfterContentInit
{
  protected readonly self = inject<ElementRef<HTMLElement>>(ElementRef);

  protected readonly trans = inject(TranslationService);

  protected readonly router = inject(Router);

  public readonly category = input.required<ServiceCategoryModel>();

  protected readonly routerSubscriber: WritableSignal<Subscription> =
    signal<Subscription>(null!);

  protected readonly currentUrl: WritableSignal<string> = signal<string>('');

  protected readonly isActive: Signal<boolean> = computed<boolean>(() => {
    const slug = this.category().slug || '';
    const url = this.currentUrl();

    return url.includes('/services') && url.includes(`/${slug}`);
  });

  protected readonly isCurrent: Signal<boolean> = computed<boolean>(() => {
    const slug = this.category().slug || '';
    const url = this.currentUrl();

    return this.isActive() && url.endsWith(`/${slug}`);
  });

  protected readonly localTitle: Signal<string> = computed<string>(() => {
    const category = this.category();

    return this.trans.trans(category.title);
  });

  protected readonly styles: Signal<any> = computed<any>(() => {
    const category = this.category();
    const styles: any = {};

    if (category.data?.leftColor) {
      styles['--color-left'] = category.data.leftColor;
    }

    if (category.data?.rightColor) {
      styles['--color-right'] = category.data.rightColor;
    }

    return styles;
  });

  public constructor() {}

  public ngOnInit(): void {
    this.currentUrl.set(this.router.url);

    this.routerSubscriber.set(
      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe({
          next: (event) => {
            this.currentUrl.set(event.url);
          },
        }),
    );
  }

  public ngOnChanges(changes: SimpleChanges) {}

  public ngOnDestroy(): void {
    this.routerSubscriber().unsubscribe();
  }

  public ngAfterContentInit(): void {}

  protected onClick(event: PointerEvent): void {
    if (!this.isCurrent()) {
      this.router.navigate([`/services/${this.category().slug}`]).then();
    }
  }
}
